module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border2",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "middle"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "part2"
    }
  }), _vm._v("PART"), _c('br'), _vm._v("TWO")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_vm._v("A Blessed"), _c('br'), _vm._v("Beginning")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border",
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "blockquotex"
  }, [_c('em', [_vm._v("“James, you are scheduled to graduate in three months. Three months of silent treatment is nothing. I believe I could live in hell for three months if I knew I was going to get out.” And, as if to underscore the lack of manhood I was exhibiting, she continued, “and I’m a woman.”")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a395013","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part02.vue
// module id = 99
// module chunks = 0